module.exports = __webpack_public_path__ + "img/mod_9.d06f3f81.png";